
// if (process.env.NODE_ENV==='development') {
  import "preact/debug";
// }
import { h, render } from 'preact';
/** @jsx h */
import Search from './search.js'
const el = document.getElementById('search-content');
render((
  <Search
    searchBasePath={el.getAttribute('data-search-base-path')}
    siteTld={el.getAttribute('data-site-tld')}
    searchStr={el.getAttribute('data-search-str') || 'apple.shop'}
  />
), el);